/* eslint-disable */
import settings from "../../../configs/settings";
import { Autocomplete, Box, Paper, TextField, Typography, Fab, Tooltip } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import PriceChangeOutlinedIcon from "@mui/icons-material/PriceChangeOutlined";
import { isNumeric } from "../../../project/utils/utils";
import CobranzaContext from "../../../project/contexts/CobranzaContext";
import { getTarjetasCredito } from "../../../project/services/MedioCobroService";
//
// ################################################################################
//
const CobroTarjetaCredito = () => {
  const [valueACTarjetaCredito, setValueACTarjetaCredito] = useState({
    id: "",
    label: "",
  });
  const [inputValueACTarjetaCredito, setInputValueACTarjetaCredito] =
    useState("");

  const {
    setMessage,
    setShowMessage,
    handleChangeMedioDeCobro,
    limpiaMedioDeCobro,
    medioDeCobroAction,
    medioDeCobro,
    setMedioDeCobro,
    agregaMedioDeCobro,
    setExpandedAccordionMediosDeCobro,
    restoACobrar,
  } = useContext(CobranzaContext);

  const [tarjetasCredito, setTarjetasCredito] = useState([]);

  const {
    idTarjetaCredito,
    descripcionTarjetaCredito,
    importe,
    numeroLote,
    numeroCupon,
    cantidadCuotas,
  } = medioDeCobro;
  const _importeAnterior = medioDeCobro.importe;
  //
  // ################################################################################
  //
  useEffect(() => {
    loadTarjetasCredito();
    setValueACTarjetaCredito({
      id: idTarjetaCredito,
      label: descripcionTarjetaCredito,
    });
  }, []);
  //
  // ################################################################################
  //
  const loadTarjetasCredito = async () => {
    const response = await getTarjetasCredito();
    if (response.ok) {
      let _tarjetasCredito = [];
      let _tarjeta = {};
      let _descripcion = "";

      response.data.data.forEach((item) => {
        _descripcion =
          item.marca_tarjeta.toUpperCase() +
          " - " +
          item.banco_entidad.toUpperCase() +
          " - " +
          item.cantidad_cuotas +
          (item.cantidad_cuotas === 1 ? " cuota" : " cuotas") +
          (item.porcentaje_descuento > 0
            ? " - " + item.porcentaje_descuento + " % descuento"
            : "") +
          (item.porcentaje_interes > 0 ? " - " + item.porcentaje_interes + " % interés" : "");
        _tarjeta = {
          idTarjeta: item.id_tarjeta,
          idTarjetaBanco: item.id_tarjeta_banco,
          idTarjetaBancoAcuerdo: item.id_tarjeta_banco_acuerdo,
          id: item.id_tarjeta_banco_acuerdo,
          porcentajeDescuento: item.porcentaje_descuento,
          porcentajeInteres: item.porcentaje_interes,
          cantidadCuotas: item.cantidad_cuotas,
          tarjeta: _descripcion,
          label: _descripcion,
        };
        _tarjetasCredito.push(_tarjeta);
      });
      setTarjetasCredito(_tarjetasCredito);
    } else {
      setTarjetasCredito([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    setMedioDeCobro({
      ...medioDeCobro,
      idTarjetaCredito: valueACTarjetaCredito.id,
      descripcionTarjetaCredito: valueACTarjetaCredito.label,
      porcentajeDescuentoTarjetaCredito: valueACTarjetaCredito.id
        ? tarjetasCredito.find((item) => item.id === valueACTarjetaCredito.id)
          .porcentajeDescuento
        : 0,
      porcentajeInteresTarjetaCredito: valueACTarjetaCredito.id
        ? tarjetasCredito.find((item) => item.id === valueACTarjetaCredito.id)
          .porcentajeInteres
        : 0,
      cantidadCuotasTarjetaCredito: valueACTarjetaCredito.id
        ? tarjetasCredito.find((item) => item.id === valueACTarjetaCredito.id)
          .cantidadCuotas
        : 0,
    });
  }, [valueACTarjetaCredito]);

  //
  // ################################################################################
  //
  const cancelaCobro = () => {
    limpiaMedioDeCobro();
    setExpandedAccordionMediosDeCobro(false);
  };
  //
  // ################################################################################
  //
  const actualizaCobro = () => {
    // valido los datos del cobro

    if (inputValueACTarjetaCredito === "") {
      setMessage({
        severity: "error",
        messageText: "Debes seleccionar una Tarjeta de Crédito",
      });
      setShowMessage(true);
      return;
    }

    if (numeroLote === "") {
      setMessage({
        severity: "error",
        messageText: "Debes ingresar el número de lote",
      });
      setShowMessage(true);
      return;
    }

    if (numeroCupon === "") {
      setMessage({
        severity: "error",
        messageText: "Debes ingresar el número de cupón",
      });
      setShowMessage(true);
      return;
    }

    if (typeof importe === "string") {
      if (!isNumeric(importe)) {
        setMessage({
          severity: "error",
          messageText: "Debes ingresar un importe mayor a 0",
        });
        setShowMessage(true);
        return;
      }
    }

    if (+importe <= 0) {
      setMessage({
        severity: "error",
        messageText: "Debes ingresar un importe mayor a 0",
      });
      setShowMessage(true);
      return;
    }

    if (
      +importe >
      (medioDeCobroAction.cu === "new" ? restoACobrar : restoACobrar + _importeAnterior)
    ) {
      setMessage({
        severity: "error",
        messageText: "El importe cobrado debe ser menor o igual al resto a cobrar",
      });
      setShowMessage(true);
      return;
    }

    // si no hay errores agrego el medio de cobro a la tabla de medios de cobro

    agregaMedioDeCobro("tarjeta-credito");
  };
  //
  // ################################################################################
  //
  const asignaRestoACobrar = () => {
    setMedioDeCobro({
      ...medioDeCobro,
      importe: restoACobrar,
    });
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Paper elevation={2} sx={{ mt: 1, p: 2 }}>
        <Typography component={"span"} variant={"body1"}>
          Tarjeta de Crédito
        </Typography>

        <Box sx={{ mt: 1 }}>
          <Autocomplete
            id="tarjetasCreditoOptions"
            size="small"
            value={valueACTarjetaCredito}
            onChange={(event, newValue) => {
              setValueACTarjetaCredito(newValue);
            }}
            inputValue={inputValueACTarjetaCredito}
            onInputChange={(event, newInputValue) => {
              setInputValueACTarjetaCredito(newInputValue);
            }}
            options={tarjetasCredito}
            renderInput={(params) => <TextField {...params} label="Tarjeta de Crédito" />}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            disableClearable={true}
          />
        </Box>
        <Box sx={{ mt: 1 }}>
          <TextField
            sx={{ width: "50%" }}
            id="numeroLote"
            label="Número de Lote"
            variant="outlined"
            size="small"
            name="numeroLote"
            value={numeroLote}
            onChange={handleChangeMedioDeCobro}
            inputProps={{
              autoComplete: "off",
            }}
          />
        </Box>
        <Box sx={{ mt: 1 }}>
          <TextField
            sx={{ width: "50%" }}
            id="numeroCupon"
            label="Número de Cupón"
            variant="outlined"
            size="small"
            name="numeroCupon"
            value={numeroCupon}
            onChange={handleChangeMedioDeCobro}
            inputProps={{
              autoComplete: "off",
            }}
          />
        </Box>
        <Box sx={{ mt: 1 }}>
          <TextField
            sx={{ width: "50%" }}
            id="importe"
            label="Importe"
            variant="outlined"
            size="small"
            name="importe"
            value={importe.toLocaleString(
              settings.numericLocales.language,
              settings.numericLocales.options
            )}
            onChange={handleChangeMedioDeCobro}
            inputProps={{
              autoComplete: "off",
              style: { textAlign: "right" },
            }}
          />
          <Tooltip title="asignar el resto a cobrar">
            <Fab
              sx={{ ml: 1, mr: 1 }}
              color="secondary"
              aria-label="add"
              size="small"
              onClick={asignaRestoACobrar}
            >
              <PriceChangeOutlinedIcon />
            </Fab>
          </Tooltip>
        </Box>

        <Box sx={{ p: 1 }}>
          <Tooltip title="agregar cobranza">
            <Fab
              sx={{ mr: 1 }}
              color="primary"
              aria-label="add"
              size="small"
              onClick={actualizaCobro}
            >
              <CheckOutlinedIcon />
            </Fab>
          </Tooltip>

          <Tooltip title="cancelar">
            <Fab
              sx={{ mr: 1 }}
              color="outlined"
              aria-label="add"
              size="small"
              onClick={cancelaCobro}
            >
              <CloseOutlinedIcon />
            </Fab>
          </Tooltip>
        </Box>
      </Paper>
    </>
  );
};

export default CobroTarjetaCredito;
